<div *ngIf="releaseStage() !== ReleaseStage.prod" [class.text-white]="whiteText">
  <h2 *ngIf="releaseStage() === ReleaseStage.uat">Test Platform</h2>
  <h2 *ngIf="releaseStage() === ReleaseStage.local">Localhost</h2>
</div>
